import * as React from "react";
import { Form, FormGroup, Button, TextArea } from "carbon-components-react";
import { connect } from "react-redux";

import APIClient from "web_modules/APIClient";

import { DEFAULT_HURDLE } from "./shared";

const styles = require("./styles.module.scss");

interface IState {
  text: string;
  invalid: boolean;
}

const initialState = (): IState => ({
  text: "",
  invalid: false,
});

interface IProps {
  appId: number;
  hurdleName?: string | null;
}

class FlagsPanel extends React.Component<IProps, any> {
  state = initialState();

  resetForm = () => this.setState(initialState());

  onChange = e => {
    const val = e.target.value;

    this.setState((prevState: IState) => ({
      text: val,
      invalid: prevState.invalid && val ? false : prevState.invalid,
    }));
  };

  onSubmit = e => {
    const { appId, hurdleName } = this.props;
    const { text } = this.state;

    e.preventDefault();

    if (!text) {
      this.setState((prevState: IState) => ({
        ...prevState,
        invalid: true,
      }));
      return;
    }

    APIClient.post("/flags", {
      application_id: appId,
      message: text,
      hurdle_name: hurdleName || DEFAULT_HURDLE,
    })
      .then(() => {
        alert("New flag created!");
        this.resetForm();
      })
      .catch(() => {
        alert("There was a problem saving your flag! Please contact eng.");
      });
  };

  render() {
    const { text, invalid } = this.state;

    return (
      <div className={styles.panelContent}>
        <Form>
          <FormGroup legendText="Add a Flag">
            <TextArea
              id="flag-text"
              name="flag-text"
              value={text}
              labelText=""
              placeholder="Flag text"
              invalidText="Text is required"
              invalid={invalid}
              onChange={this.onChange}
            />
          </FormGroup>
          <div className={styles.buttons}>
            <Button kind="secondary" tabIndex={0} onClick={this.resetForm}>
              Cancel
            </Button>
            <Button kind="primary" type="submit" tabIndex={0} onClick={this.onSubmit}>
              Save
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  hurdleName: state.operator.currentHurdleName,
});

const ConnectedFlagsPanel = connect<any>(mapStateToProps)(FlagsPanel);

export default ConnectedFlagsPanel;
